exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.quote {\n    position: relative;\n}\n.card {\n    height: 100%;\n    width: 100%;\n}\n.quote:before {\n    content: '\\201C';\n    position: absolute;\n    font-family: serif;\n    font-weight: 700;\n    top: -40px;\n    left: -10px;\n    font-size: 130px;\n    color: blue;\n    opacity: 0.1;\n}\n", ""]);

// exports
